var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlusCircle24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_plus-circle_24px",
    "data-name": "icon/plus-circle_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pluc-circle-r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M12.75,11.25h4v1.5h-4v4h-1.5v-4h-4v-1.5h4v-4h1.5Z",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M2.25,12A9.75,9.75,0,1,1,12,21.75,9.75,9.75,0,0,1,2.25,12ZM12,3.75A8.25,8.25,0,1,0,20.25,12,8.25,8.25,0,0,0,12,3.75Z",
    fill: "#3bb0ff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircle24Px);
export default __webpack_public_path__ + "static/media/icon-plus-circle_24px.b8da2145449003751c3241fae131d292.svg";
export { ForwardRef as ReactComponent };